/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
// import { MdStarBorder, MdStar } from 'react-icons/md';
import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';;

import PropTypes from 'prop-types';

import { Button } from '@material-ui/core';

import AppConfigRobotType from '~/components/AppConfigRobotType';
// import ExitDialog from '~/components/ExitDialog';
// import FormSelect from '~/components/Form/Select';
import LocaleMessage from '~/components/LocaleMessage';
import Splash from '~/components/Splash/Inside';

// import api from '~/services/pluginbot-api';

// const features = {
//     cruzr: {
//         max_speed: true,
//         reference_point_id: true,
//         show_location: true,
//         speed_selection: true,
//     },
//     temi_go: {
//         reference_point_id: true,
//     },
// };

export default function Settings({
    app,
    group: _group,
    handleError: _handleError,
    needSaving: _needSaving,
    setNeedSaving: _setNeedSaving,
    updateObject,
    robotTypes,
    currType,
    setCurrType,
}) {
    // const _settings = useSelector(state => state.settings || null);

    const { settings: appConfig } = app;

    const appSettings =
        appConfig && appConfig.settings ? appConfig.settings : {};

    const [isLoading] = useState(false);

    // const [dialogOpen, setDialogOpen] = useState(false);

    const [config] = useState(
        appSettings && appSettings.config
            ? appSettings.config
            : { active: false }
    );

    const r_key = currType.slug ? currType.slug : 'all';
    const r_type_settings = config[r_key] || {};
    // const robot_features = nav_features[r_key] || {};

    // useEffect(() => {
    //     if (app_type && app_type.id) {
    //     }
    // }, [app_type, currType]);

    useEffect(() => {}, [r_type_settings.map_layer_id, currType]);

    // function buildConfirmDialog() {
    //     return (
    //         <ExitDialog
    //             open={dialogOpen}
    //             onClose={() => setDialogOpen(false)}
    //             destination="/tools/maps"
    //         />
    //     );
    // }

    async function handleSubmit() {
        const data = { config };
        updateObject(data);
    }

    function renderSubmitButton() {
        return (
            <div className="col-12 mt-2">
                <Button
                    className="p-3"
                    variant="contained"
                    color="primary"
                    onClick={() => handleSubmit()}
                    fullWidth
                    size="large"
                    // disabled={!needSaving}
                >
                    <LocaleMessage msg="button.save" />
                </Button>
            </div>
        );
    }

    function renderConfig() {
        return (
            <div
                className="col-md-6 col-12 row mb-5"
                style={{ display: 'flex', alignItems: 'center' }}
            >
                <div
                    className="col-12 mt-1 row"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <div className="col-12" />
                    {renderSubmitButton()}
                </div>
            </div>
        );
    }

    return (
        <div className="col-12 mb-3 row">
            <div className="sidecard-header">
                <h2>
                    <LocaleMessage msg="label.settings.app.indoor_delivery.settings" />
                </h2>
            </div>

            <div className="sidecard-body">
                {isLoading ? (
                    <Splash />
                ) : (
                    <>
                        <div
                            className="col-12"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <AppConfigRobotType
                                className="col-12 mb-5"
                                robotTypes={robotTypes}
                                currType={currType}
                                setCurrType={t => setCurrType(t)}
                            >
                                {renderConfig()}
                            </AppConfigRobotType>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

Settings.defaultProps = {};

Settings.propTypes = {
    app: PropTypes.object.isRequired,
    group: PropTypes.string.isRequired,
    updateObject: PropTypes.func.isRequired,
    handleError: PropTypes.func.isRequired,
    needSaving: PropTypes.bool.isRequired,
    setNeedSaving: PropTypes.func.isRequired,
    robotTypes: PropTypes.array.isRequired,
    currType: PropTypes.object.isRequired,
    setCurrType: PropTypes.func.isRequired,
};
